import { get } from '../utils/axios'

export const getIncomeOTFlatrateTypeAPI = async () => {
  return await get('income/ot/flatrate/type')
}

export const getIncomeShiftFlatrateTypeAPI = async () => {
  return await get('income/shift/flatrate/type')
}

export const getIncomeLangFeeTypeAPI = async () => {
  return await get('income/lang/fee/type')
}

export const getIncomeExpFeeTypeAPI = async () => {
    return await get('income/exp/fee/type')
  }
  
